import { CookieResponseContext } from '@rhg/providers/cookie-response';
import { useContext } from 'react';

export function useCookieResponse() {
    return useContext(CookieResponseContext);
}
